import { LoadingButton } from '@mui/lab';
import { Box, Card, Container, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Header from 'src/layouts/dashboard/header/header.component';
import { CommonHelper } from 'src/utils/commonHelper';
import { useToaster } from 'src/utils/toaster/toasterContext';
import UserDisableIcon from '../../assets/icons/user-disable.svg';

const DisableUserComponent = () => {
  const { t: translate } = useTranslation();

  const { showToast } = useToaster();
  const navigate = useNavigate();

  const isCustomDomain = CommonHelper.CustomDomain();

  const [isLeaveOrgLoading, setLeaveOrgLoading] = useState(false);

  useEffect(() => {
    const isUserEnabled = CommonHelper.GetBrandInfoFromLocalStorage('is_user_enabled');
    if (isUserEnabled) {
      navigate(CommonHelper.GetDefaultPermissionRoute());
    }
  }, []);

  const successCallback = (data, message) => {
    message && showToast(message, 's');
    setLeaveOrgLoading(false);
    navigate('/no-organization');
  };

  const failureCallback = (message) => {
    message && showToast(message, 'e');
    setLeaveOrgLoading(false);
  };

  const handleLeaveOrganization = () => {
    setLeaveOrgLoading(true);
    CommonHelper.LeaveOrganization(successCallback, failureCallback);
  };

  return (
    <>
      <Helmet>
        <title> {translate('disable_user.user_disabled')} </title>
      </Helmet>
      <Header headerName={''} />
      <Container>
        <div
          style={{
            display: 'flex',
            minHeight: '100%',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 10,
          }}
        >
          <Container>
            <Box sx={{ maxWidth: 680, mx: 'auto' }}>
              <Card sx={{ py: 3, px: 3, textAlign: 'center' }}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <img src={UserDisableIcon} style={{ height: 300 }} />
                </Box>
                <Typography variant="h3" paragraph>
                  {translate('disable_user.user_has_been_disabled')}
                </Typography>
                <Typography sx={{ color: 'text.secondary', mb: 3 }}>
                  {translate('disable_user.contact_admin')}
                </Typography>
                {!isCustomDomain && (
                  <LoadingButton
                    variant="contained"
                    size="large"
                    loading={isLeaveOrgLoading}
                    fullWidth
                    onClick={handleLeaveOrganization}
                  >
                    {translate('brand.leave_organization')}
                  </LoadingButton>
                )}
              </Card>
            </Box>
          </Container>
        </div>
      </Container>
    </>
  );
};
export default DisableUserComponent;
